import React, { useState } from 'react';
import logo from './images/logo.png';
import Show051723 from './images/Shows/05-17-23.jpg';
import Show070923 from './images/Shows/07-09-23.jpg';
import Show102623 from './images/Shows/10-26-23.jpg';
import Show031524 from './images/Shows/03-15-24.jpg';
import Show033024 from './images/Shows/03-30-24.jpg';
import Show071824 from './images/Shows/07-18-24.jpg';
import Show080324 from './images/Shows/08-03-24.jpg';
import Show101624 from './images/Shows/10-16-24.jpg';
import Show040525 from './images/Shows/04-05-25.jpg';
import Show052326 from './images/Shows/05-23-26.jpg';
import Show062125 from './images/Shows/06-21-25.jpg';
import { SocialIcon } from 'react-social-icons';
import Modal from 'react-modal';

import './App.css';

function App() {

  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setShowModal(false);
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h2 className="About" style={{ fontSize: "40px", marginTop: "0" }}>
          Portland, OR
        </h2>
        <p style={{ fontSize: "30px" }}>Unique | Alternative rock | Hard Rock | Metal | Punk</p>
      </header>
      <div className="Header-separator"></div>
      <div className="Header-fade"></div>

      <div className="Lineup" style={{ gap: "20px", fontSize: "20px", display: "flex", flexWrap: "wrap", flexDirection: "row", justifyContent: "space-around", padding: "20px" }}>
        <span><span>Matthew Gordon:</span>
          <span>&nbsp;Vocals</span></span> |
        <span><span>Xeno Miller:</span>
          <span>&nbsp;Drums</span></span> |
        <span><span>Matthew Kellog:</span>
          <span>&nbsp;Guitar</span></span> |
        <span><span>Michael OLeary Jr:</span>
          <span>&nbsp;Bass</span></span>
      </div>

      <h3 style={{ marginTop: "45px" }}>Come See Us Live!</h3>
      <div className="Shows">
        <img onClick={() => openModal(Show052326)} src={Show052326} className="Content clickable" alt="Show at The World Famoustm on 05-23-26" />
        <img onClick={() => openModal(Show062125)} src={Show062125} className="Content clickable" alt="Show at The Firkin Tavern on 06-21-25" />
        <img onClick={() => openModal(Show040525)} src={Show040525} className="Content clickable" alt="Show at The Hawthorn Hideaway on 04-05-25" />
        <img onClick={() => openModal(Show101624)} src={Show101624} className="Content clickable" alt="Show at Thatchers on 10-16-24" />
        <img onClick={() => openModal(Show080324)} src={Show080324} className="Content clickable" alt="Show at Bridge City Sessions on 08-03-24" />
        <img onClick={() => openModal(Show071824)} src={Show071824} className="Content clickable" height="300" width="250" alt="Show at No Fun Bar on 07-18-24" />
        <img onClick={() => openModal(Show033024)} src={Show033024} className="Content clickable" alt="Show at Breakside Brewery on 03-30-24" />
        <img onClick={() => openModal(Show031524)} src={Show031524} className="Content clickable" alt="Show at Twilight on 03-15-23" />
        <img onClick={() => openModal(Show102623)} src={Show102623} className="Content clickable" alt="Show at Dante's on 10-26-23" />
        <img onClick={() => openModal(Show070923)} src={Show070923} className="Content clickable" alt="Show at No Fun Bar on 07-09-23" />
        <img onClick={() => openModal(Show051723)} src={Show051723} className="Content clickable" alt="Show at High Water Mark on 05-17-23" />
      </div>
      <Modal
        isOpen={showModal}
        onRequestClose={closeModal}
        contentLabel="Image Modal"
        style={{
          content: {
            maxWidth: 'fit-content',
            maxHeight: 'fit-content',
            padding: 0,
            margin: 0
          }
        }}
      >
        {selectedImage && <img src={selectedImage} alt="Selected Show" style={{ maxWidth: '90vw', maxHeight: '90vh' }} />}
      </Modal>

      <hr />
      <h3 style={{ marginTop: "50px", marginBottom: "50px" }}>Watch & Listen on Youtube!</h3>

      <div className="Youtube">

        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/x4wrmw6flO0?si=YHk0bWsKr34NCzeg"
          title="Mad Gods live at No Fun - Reason to Live"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen>
        </iframe>
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/9jFJL0C-VPI?si=Zs1vjANDTMY84yuI"
          title="Breakside Brewery Saturday March 30 2024"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen>
        </iframe>
        <iframe
          className="Content"
          width="560"
          height="315"
          src="https://youtube.com/embed/KJC3G2eDi9w?si=E50PsSQ2I3J75KOL"
          title="Burnin Sun - March 15 Promo"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        >
        </iframe>
        <iframe
          className="Content"
          width="560"
          height="315"
          src="https://www.youtube.com/embed/LNu5VMfqBRc?si=UjcjaCr2W0p9uzDA"
          title="Calling Your Name"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
        <iframe
          className="Content"
          width="560"
          height="315"
          src="https://www.youtube.com/embed/acPlrLJkS6I?si=SgZ8wHP45e8ji-ad"
          title="Mary Jane"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
        <iframe
          className="Content"
          width="560"
          height="315"
          src="https://www.youtube.com/embed/wspehUUsFRY?si=S6zMBvgS3yRBTP_5"
          title="Burnin Sun"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>

      <hr />
      <h3 style={{ marginTop: "50px", marginBottom: "0" }}>Listen on Bandcamp!</h3>

      <div className="bandcamp-player">
        <iframe
          title="Calling Your Name - Single by Mad Gods"
          style={{ border: 0, width: "350px", maxWidth: "100vw", height: "470px" }}
          src="https://bandcamp.com/EmbeddedPlayer/album=397262956/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/"
          seamless
        >
          <a href="https://madgods.bandcamp.com/album/calling-your-name-single">
            Calling Your Name - Single by Mad Gods
          </a>
        </iframe>
      </div>

      <hr />
      <h4>Socials</h4>
      <div>

        <SocialIcon className="Content" url="https://www.facebook.com/madgodspdx/" />
        <SocialIcon className="Content" url="https://www.instagram.com/madgodspdx/" />
        <SocialIcon className="Content" url="https://www.youtube.com/@MadGodsBand" />
      </div>

      <div>
        <br />
        Copyright © 2020-{new Date().getFullYear()} Mad Gods Band ®
        <br />
        <br />
        <br />
      </div>
    </div>
  );

}

export default App;
